module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [_c('h1', [_vm._v("FAQ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('adsense', {
    attrs: {
      "ad-client": "ca-pub-8213113866781504",
      "ad-slot": "1950798677",
      "ad-style": "display:inline-block;width:468px;height:60px",
      "ad-format": "auto"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', [_vm._v("I just paid for premium picks, how do I view picks?")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h5', [_vm._v("Do you email picks?")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h5', [_vm._v("Can I view picks on my smartphone?")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h5', [_vm._v("I just registered for the website, how do I view free picks?")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('h5', [_vm._v("I'm a premium member, how come the free picks do not show when I click \"View Picks?\"")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('h5', [_vm._v("What are units?")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('h5', [_vm._v("Most of your picks are for 1 unit, do you ever deviate from betting this unit?")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('adsense', {
    attrs: {
      "ad-client": "ca-pub-8213113866781504",
      "ad-slot": "1950798677",
      "ad-style": "display:inline-block;width:468px;height:60px",
      "ad-format": "auto"
    }
  })], 1), _vm._v(" "), _c('sidebar', {
    attrs: {
      "testimonial": _vm.testimonial
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Stumpthespread strives to make this website intuitive and easy to use, however we know there will be many questions about the functionality of this site. This document should solve most of your questions. If it does not, please send us an email through our "), _c('a', {
    attrs: {
      "href": "contact.php"
    }
  }, [_vm._v("contact")]), _vm._v(" page.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("Log into the website using the \"Login\" button found at the top right of the website. Once logged in, click \"View Picks\" which appears next to your email address also found in the top right of the website.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("Yes, when you are a premium member, you can set up pick notifications for email or text message.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("You can view the website in your smartphone's browser. We are currently working on a web app for smartphones to make it easier to view picks.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("Once logged in, click \"Free Picks\" in the navigation bar.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("Free picks are of a lower confidence level therefore we do not include them in the \"View Picks\" view or in our Results page when they are not represented as a premium pick. If you would like to look at the free picks, you will have to click \"Free Picks\" found in the navigation bar.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("Units are a measurement of the size of a bet. This size is relative to your bankroll. A unit should be between 0.5 - 1% of your bankroll. For example, if you have $10,000 and we have a pick for 1 unit, that would be $50 - $100. Keeping your unit size small limits your risk of ruin.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("Our system calls for mainly 1 unit picks. When we deviate and bet more on a game it will be because it fits one of our high unit systems.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("If you have any further questions, please consult us via email at our "), _c('a', {
    attrs: {
      "href": "contact.php"
    }
  }, [_vm._v("contact")]), _vm._v(" page.")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4e2e808c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Faq.vue
// module id = 497
// module chunks = 1